(() => {
  if (customElements.get('meltonia-pdp-research')) return;
  class MeltoniaPdpResearch extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      const nav = this.querySelector('[data-research-tabs]');
      const tabs = [...this.querySelectorAll('[data-research-tab]')];
      const panels = [...this.querySelectorAll('[data-research-panel]')];
      if (!nav || tabs.length < 2 || panels.length !== tabs.length || tabs.some(tab => !panels.some(panel => panel.id === tab.getAttribute('aria-controls')))) return;
      const ghostTab = tabs.find(tab => tab.dataset.researchTab === 'ghost');
      const ghostPanel = panels.find(panel => panel.dataset.researchPanel === 'ghost');
      const assessments = ghostPanel?.querySelectorAll('[data-ghost-completeness-percent]') ?? [];
      const assessment = assessments.length === 1 ? assessments[0] : null;
      const percent = assessment?.getAttribute('data-ghost-completeness-percent') ?? '';
      if (ghostTab) ghostTab.textContent = assessment?.tagName === 'SPAN' && /^(?:0|[1-9]\d?|100)$/.test(percent)
        ? `Ghost Index · ${percent}%` : 'Ghost Index';
      this.connected = true;
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          panels.find(panel => panel.id === item.getAttribute('aria-controls')).hidden = !active;
        });
        if (focus) tab.focus();
        if (tab.dataset.researchTab === 'comps') window.dispatchEvent(new Event('resize'));
      };
      this.clickHandler = event => {
        const tab = event.target.closest('[data-research-tab]');
        if (tabs.includes(tab)) select(tab);
      };
      this.keyHandler = event => {
        const index = tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(index + tabs.length - 1) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs.at(-1);
        if (next) { event.preventDefault(); select(next, true); }
      };
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', 'Card research options');
      tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs.find(tab => tab.getAttribute('aria-controls') === panel.id).id);
        panel.tabIndex = 0;
      });
      nav.addEventListener('click', this.clickHandler);
      nav.addEventListener('keydown', this.keyHandler);
      select(tabs[0]);
      nav.hidden = false;
      this.dataset.enhanced = 'true';
    }
    disconnectedCallback() {
      const nav = this.querySelector('[data-research-tabs]');
      nav?.removeEventListener('click', this.clickHandler);
      nav?.removeEventListener('keydown', this.keyHandler);
      this.connected = false;
    }
  }
  customElements.define('meltonia-pdp-research', MeltoniaPdpResearch);
})();
